import Helper from './Helper';

class HoverImg {
  constructor(config = {}) {
    const hoverImgs = document.querySelectorAll('.ns-img-hover-alt__img-wrap');

    [...hoverImgs].forEach(img => {
      img.addEventListener('click', e => {
        if(img.classList.contains('hover')){
          img.classList.remove('hover');
        } else {
          img.classList.add('hover');
        }
      });

      img.addEventListener('touchstart', e => {
        // prevent duplicate clicks
        e.preventDefault()

        e.target.dispatchEvent(new Event('click'));
      });
    });

  }
}

export default HoverImg;
